import { registerPlugin } from '@capacitor/core';
import { ConnectionData } from './watchconnect';

export interface WatchConnect {
    saveWidget(options: ConnectionData): Promise<{result: boolean}>;
}
const WidgetConnect = registerPlugin<WatchConnect>('Widget');

export default WidgetConnect;
